class StoreUpdator extends HTMLElement {
  constructor() {
    super();
    this.current_store_id = localStorage.getItem('global_store_id');
    this.store_search = document.getElementById('store_update_search');
    this.store_list    = this.querySelector('.store-search-dropdown-content');
    this.store_dropdown = this.querySelector('.store-search_dropdown');
    this.mobile_popup_button = document.querySelector('.header__location-data--mobile');


    this.appendStoreElements = this.appendStoreElements.bind(this);
    this.handleStoreSearch = this.handleStoreSearch.bind(this);
    // this.handleStoreList = this.handleStoreList.bind(this);
  }

  connectedCallback() {
    this.current_store_title = this.querySelector('.js-current__store-title');
    this.store_distance = this.querySelector('.js-current__store-distance');
    this.store_status = this.querySelectorAll('.js-current__store-status');
    this.fullfill = this.querySelector('.js-current__store-fullfill');
    this.store_address = this.querySelector('.js-current__store-address');
    this.delivery_disclaimer = this.querySelector('.store-update__delivery-disclaimer');

    this.handleStoreList();
    this.handleStoreUpdate();
    this.handleShopHere();

    // this.mobile_popup_button.querySelector('.js-header-store-name').innerHTML = "Change Your Store";
    // this.mobile_popup_button.querySelector('.js-header-street').innerHTML = "";
    if (this.current_store_title) {
      this.setCurrentStoreDetails();
    } else {
      console.error("StoreUpdator: .js-current__store-title not found");
    }

    if (this.store_search) {
      this.store_search.addEventListener('input', this.handleStoreSearch);
    } else {
      console.error("StoreUpdator: #store_update_search not found");
    }
    
    // Note: Delivery/pickup preference changes now trigger page reload
    // No need for complex refresh logic
    
    // Restore header state on page load (with delay to ensure buttons are set up first)
    setTimeout(() => {
      this.restoreHeaderStateOnLoad();
    }, 1000); // Increased delay to ensure other scripts have run
    
    // Add periodic sync check to ensure modal stays updated
    // Instead:
document.addEventListener('storeChanged', () => {
  this.forceUpdateModalWithCurrentStore();
});
    
    // Watch for modal opening and sync immediately
    this.setupModalObserver();
    
    // Ensure modal shows correct store on initialization
    setTimeout(() => {
      this.ensureModalShowsCorrectStore();
    }, 1000);
    
    // Retry initialization if stores are not loaded yet
    if (!window.stores) {
      console.log('Store popup: Stores not loaded yet, retrying in 1 second');
      setTimeout(() => {
        this.retryInitialization();
      }, 1000);
    }
  }

  // Ensure modal always shows the correct store
  ensureModalShowsCorrectStore() {
    console.log('🔄 Store update: Ensuring modal shows correct store...');
    
    const currentStoreId = localStorage.getItem('global_store_id');
    console.log('🔍 Ensure correct store - Current store ID:', currentStoreId);
    
    if (currentStoreId && window.stores) {
      const currentStore = Object.values(window.stores).find(store => store.store_id === currentStoreId);
      if (currentStore) {
        console.log('📦 Ensure correct store - Found store:', currentStore.title);
        
        // Update the instance store ID
        this.current_store_id = currentStoreId;
        
        // Force update the modal display
        this.restoreSelectedStoreInModal(currentStore);
        
        // Also update the current store details
        this.setCurrentStoreDetails();
        
        console.log('✅ Modal ensured to show correct store:', currentStore.title);
      } else {
        console.warn('⚠️ Ensure correct store - Store not found for ID:', currentStoreId);
      }
    } else {
      console.warn('⚠️ Ensure correct store - No store ID or stores not available');
    }
  }

  getStoreTimeZone(store) {
    const province = store && store.address ? store.address.province : '';
    const map = {
      'British Columbia': 'America/Vancouver',
      'Alberta': 'America/Edmonton',
      'Saskatchewan': 'America/Regina',
      'Manitoba': 'America/Winnipeg',
      'Ontario': 'America/Toronto',
      'Quebec': 'America/Toronto',
      'New Brunswick': 'America/Moncton',
      'Nova Scotia': 'America/Halifax',
      'Prince Edward Island': 'America/Halifax',
      'Newfoundland and Labrador': 'America/St_Johns',
      'Yukon': 'America/Whitehorse',
      'Northwest Territories': 'America/Edmonton',
      'Nunavut': 'America/Iqaluit',
    };
    return map[province] || 'America/Toronto';
  }

  getStoreLocalDateParts(store) {
    const timeZone = this.getStoreTimeZone(store);
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());
    const lookup = {};
    parts.forEach((part) => {
      lookup[part.type] = part.value;
    });
    const weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      day: weekdayMap[lookup.weekday],
      time: `${lookup.hour}${lookup.minute}`,
    };
  }

  updateDeliveryDisclaimer(store) {
    if (!this.delivery_disclaimer) return;

    const isDeliverySelected = localStorage.getItem('age_verification_delivery') === 'true';
    const HUB_DISCLAIMER_TEXT = {
      'district': 'DISCLAIMER: All express delivery sales within Calgary are processed, fulfilled, and delivered by Canna Cabana District (Licence # 782387), located at Unit 130, 11130 11th Street NE, Calgary, AB T3K 2R5.',
      'eastlake': 'DISCLAIMER: All express delivery sales within Calgary are processed, fulfilled, and delivered by Canna Cabana East Lake (Licence # 782390), located at Unit #16 10822 50 Street SE, Calgary, AB T2C 2X8.',
    };
    const hubId = store && store.hub_id != null ? String(store.hub_id).trim().toLowerCase() : '';
    const disclaimerText = HUB_DISCLAIMER_TEXT[hubId] || '';

    if (this.fullfill) {
      const serviceButtonsContainer = this.fullfill.querySelector('.service-buttons-container');
      if (serviceButtonsContainer) {
        const nextSibling = serviceButtonsContainer.nextSibling;
        if (this.delivery_disclaimer.parentElement !== this.fullfill) {
          this.fullfill.insertBefore(this.delivery_disclaimer, nextSibling);
        } else if (this.delivery_disclaimer.previousSibling !== serviceButtonsContainer) {
          this.fullfill.insertBefore(this.delivery_disclaimer, nextSibling);
        }
      }
    }

    if (isDeliverySelected && disclaimerText) {
      this.delivery_disclaimer.classList.remove('hidden');
      const textEl = this.delivery_disclaimer.querySelector('.store-update__delivery-disclaimer-text');
      if (textEl) textEl.textContent = disclaimerText;
    } else {
      this.delivery_disclaimer.classList.add('hidden');
    }
  }

  setCurrentStoreDetails() {
    if (!window.stores) {
      console.error("StoreUpdator: window.stores is undefined, retrying in 500ms");
      // Retry after a short delay to allow stores to load
      setTimeout(() => {
        this.setCurrentStoreDetails();
      }, 500);
      return;
    }

    const matchedStore = Object.values(window.stores).find(
      (store) => store.store_id === this.current_store_id
    );

    if (!matchedStore) {
      console.warn("StoreUpdator: No matching store found");
      this.current_store_title.innerHTML = "Store not found";
      return;
    }

    this.current_store_title.innerHTML = matchedStore.title || "";
    this.updateDeliveryDisclaimer(matchedStore);

    // Handle distance
    const distance = localStorage.getItem('global_store_distance');
    let status = "Closed";
    if (matchedStore.hours_periods && Array.isArray(matchedStore.hours_periods)) {
      const { day, time: currentTime } = this.getStoreLocalDateParts(matchedStore);
      const todayHours = matchedStore.hours_periods.find(h => h.open.day === day);
      if (todayHours) {
        const openTime = todayHours.open.time;
        const closeTime = todayHours.close.time;
        if (closeTime < openTime) {
          status = (currentTime >= openTime || currentTime <= closeTime) ? "Open" : "Closed";
        } else {
          status = (currentTime >= openTime && currentTime <= closeTime) ? "Open" : "Closed";
        }
      }
    }
    localStorage.setItem('global_store_status', status);
    let fullfill_p;
    let fullfill_d;
    
    // Use new age verification variables
    const isDeliverySelected = localStorage.getItem('age_verification_delivery') === 'true';
    const isPickupSelected = localStorage.getItem('age_verification_pickup') === 'true';
    
    // Check if store has hub_id for express delivery or has_delivery for normal delivery
    const hasHubId = matchedStore.hub_id && matchedStore.hub_id !== '';
    const hasNormalDelivery = matchedStore.has_delivery === true;
    
    if (isDeliverySelected && (hasHubId || hasNormalDelivery)) {
      fullfill_p = "Pickup";
      fullfill_d = "Delivery";
    } else {
      // Default to pickup only (no delivery capability or pickup selected)
      fullfill_p = "Pickup";
      fullfill_d = null;
    }
    console.log(fullfill_p,"fullfill_p",fullfill_d,"fullfill_d")
    if (distance && !isNaN(parseFloat(distance))) {
      const roundedDistance = this.roundToNearestHalf(parseFloat(distance));
      this.store_distance.innerHTML = `${roundedDistance} km away`;
     this.store_status.forEach(ele => {
        ele.innerHTML = `${status}`;
        ele.classList.remove('open', 'closed'); // reset first
        if (status === "Open") {
          ele.classList.add('open');
        } else {
          ele.classList.add('closed');
        }
      });
    } else {
      this.store_status.forEach(ele => {
        ele.innerHTML = `${status}`;
        ele.classList.remove('open', 'closed'); // reset first
        if (status === "Open") {
          ele.classList.add('open');
        } else {
          ele.classList.add('closed');
        }
      });
    }
    // Add Open status badge only
    const statusBadge = status === "Open" ? '<span class="d-tag open">Open</span>' : '<span class="d-tag closed">Closed</span>';
    
     // Create service buttons HTML if store offers any type of delivery
     const buttonsHTML = (hasHubId || hasNormalDelivery) ? `
       <div class="store-service-buttons">
         <button class="service-button pickup-button ${isPickupSelected ? 'active' : ''}" data-service="pickup">
           <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" stroke-width="2"/>
             <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" stroke-width="2"/>
           </svg>
           Pickup
         </button>
         <button class="service-button delivery-button ${isDeliverySelected ? 'active' : ''}" data-service="delivery">
           <svg width="16" height="16" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M3 5H15C15.5523 5 16 5.44772 16 6V14H5C3.34315 14 2 12.6569 2 11V6C2 5.44772 2.44772 5 3 5Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
             <path d="M16 8H19.5L22 11V14H16V8Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
             <circle cx="6.5" cy="16.5" r="2.5" stroke="currentColor" stroke-width="2"/>
             <circle cx="18.5" cy="16.5" r="2.5" stroke="currentColor" stroke-width="2"/>
             <path d="M9 16.5H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
           </svg>
           ${hasHubId ? 'Express Delivery' : 'Delivery'}
         </button>
       </div>
     ` : '';

     // Create delivery information HTML
     const deliveryInfoHTML = (hasHubId || hasNormalDelivery) ? `
       <div class="same-day-delivery">
         ${hasHubId ? `
           <p class="delivery-speed">In as little as <strong>35 minutes*</strong></p>
           <h2>Order before 7PM to get<br><span class="highlight">SAME-DAY DELIVERY</span></h2>
           <p class="availability">Available Sun – Sat, 12 PM – 8 PM</p>
           <p class="note">Orders placed after 7PM will have next-day delivery during delivery hours.</p>
           <div class="free-delivery">
             <div class="icon">
               <img src="https://cdn.shopify.com/s/files/1/0520/7713/4012/files/dollar-img.png?v=1760652920" alt="Free Icon" style="width: 38px; height: 38px; object-fit: contain;">
             </div>
             <div class="text">
               <p class="free">FREE on orders <strong>$50+</strong> (pre-tax)</p>
               <p class="fee">$9.99 fee for orders under $50</p>
             </div>
           </div>
           <p class="disclaimer">
             *We aim to deliver in as little as 35 minutes, but timing may vary due to traffic or weather.
              If your delivery takes longer than 90 minutes, please <a href="pages/store/${matchedStore.handle}">contact your local store</a>.
             Delivery orders are fulfilled from our central location. Product selection may differ from your local store.
           </p>
         ` : `
           <p class="delivery-speed">Standard <strong>delivery available</strong></p>
           <h2>Order before ${this.getStoreClosingTime(matchedStore)} for<br><span class="highlight">SAME-DAY DELIVERY</span></h2>
           <p class="availability">Available ${this.getStoreDeliveryDays(matchedStore)}</p>
           <p class="note">Orders placed after ${this.getStoreClosingTime(matchedStore)} will have next-day delivery during delivery hours.</p>
           <div class="free-delivery">
             <div class="icon">
               <img src="https://cdn.shopify.com/s/files/1/0520/7713/4012/files/dollar-img.png?v=1760652920" alt="Free Icon" style="width: 38px; height: 38px; object-fit: contain;">
             </div>
             <div class="text">
               <p class="free">FREE on orders <strong>$50+</strong> (pre-tax)</p>
               <p class="fee">$9.99 fee for orders under $50</p>
             </div>
           </div>
           <p class="disclaimer">
             Delivery orders are fulfilled from our central location. Product selection may differ from your local store.
             Please <a href="/?sID=${matchedStore.store_id}">contact your local store</a> for delivery timing questions.
           </p>
         `}
       </div>
     ` : '';
     
     // Update the fullfill section with status badge, buttons, and delivery info
     this.fullfill.innerHTML = `
       <div class="service-buttons-container">
         ${buttonsHTML}
       </div>
       <div class="delivery-info-container">
         ${deliveryInfoHTML}
       </div>
     `;
    
    // Add event listeners for service buttons and check express delivery
    setTimeout(async () => {
      const pickupButton = this.fullfill.querySelector('.pickup-button');
      const deliveryButton = this.fullfill.querySelector('.delivery-button');
      const serviceButtonsContainer = this.fullfill.querySelector('.service-buttons-container');
      const deliveryInfo = this.fullfill.querySelector('.same-day-delivery');
      
      // Check for test parameter to force show buttons
      const urlParams = new URLSearchParams(window.location.search);
      const forceShowButtons = urlParams.get('test_show_buttons') === 'true';
      
      // Always show buttons for stores with any delivery capability
      const hasAnyDelivery = hasHubId || hasNormalDelivery;
      
      if (hasAnyDelivery || forceShowButtons) {
        // Show the service buttons container
        if (serviceButtonsContainer) {
          serviceButtonsContainer.classList.add('show');
          serviceButtonsContainer.classList.remove('hidden');
          if (forceShowButtons) {
            console.log('🧪 TEST MODE: Showed service buttons container (forced by URL parameter)');
            // Add test mode indicator
            serviceButtonsContainer.style.border = '2px dashed #ff6b35';
            serviceButtonsContainer.style.backgroundColor = '#fff3e0';
            serviceButtonsContainer.style.padding = '10px';
            serviceButtonsContainer.style.borderRadius = '8px';
            serviceButtonsContainer.setAttribute('title', 'TEST MODE: Buttons shown via URL parameter test_show_buttons=true');
          } else {
            console.log('📝 Showed service buttons container (delivery available)');
          }
        }
        // Show both buttons for any store with delivery capability
        if (deliveryButton) {
          deliveryButton.style.display = '';
          deliveryButton.disabled = false;
          console.log('📝 Showed delivery button (delivery available)');
        }
        if (pickupButton) {
          pickupButton.style.display = '';
          pickupButton.disabled = false;
          console.log('📝 Showed pickup button (delivery available)');
        }
        
        // Check express delivery API only for stores with hub_id
        if (hasHubId) {
          try {
            const isExpressDeliveryAvailable = await this.checkExpressDeliveryForStore(matchedStore);
            console.log('🚀 Express delivery available for store details:', isExpressDeliveryAvailable);
            
            if (!isExpressDeliveryAvailable && !hasNormalDelivery) {
              // Hide service buttons container if express delivery is not available AND no normal delivery
              if (serviceButtonsContainer) {
                serviceButtonsContainer.classList.remove('show');
                serviceButtonsContainer.classList.add('hidden');
                console.log('📝 Hidden service buttons container (no delivery available)');
              }
              
              // Only hide buttons if express delivery is not available AND no normal delivery
              if (deliveryButton) {
                deliveryButton.style.display = 'none';
                deliveryButton.disabled = true;
                console.log('📝 Hidden delivery button (no delivery available)');
              }
              if (pickupButton) {
                pickupButton.style.display = 'none';
                pickupButton.disabled = true;
                console.log('📝 Hidden pickup button (no delivery available)');
              }
              
              // If delivery was selected but not available, clear selections
              if (isDeliverySelected) {
                localStorage.setItem('age_verification_delivery', 'false');
                localStorage.setItem('age_verification_pickup', 'false');
                console.log('📝 Cleared delivery/pickup selections (no delivery available)');
              }
            }
          } catch (error) {
            console.error('Error checking express delivery for store details:', error);
            // On error, keep buttons visible if store has any delivery capability
            console.log('📝 Keeping buttons visible due to API error (store has delivery capability)');
          }
        }
      } else {
        // Hide service buttons container when no delivery is available at all
        if (serviceButtonsContainer) {
          serviceButtonsContainer.classList.remove('show');
          serviceButtonsContainer.classList.add('hidden');
          console.log('📝 Hidden service buttons container (no delivery available)');
        }
        
        // Hide both buttons when no delivery is available at all
        if (deliveryButton) {
          deliveryButton.style.display = 'none';
          deliveryButton.disabled = true;
          console.log('📝 Hidden delivery button (no delivery available)');
        }
        if (pickupButton) {
          pickupButton.style.display = 'none';
          pickupButton.disabled = true;
          console.log('📝 Hidden pickup button (no delivery available)');
        }
        
        // If delivery was selected but not available, clear selections
        if (isDeliverySelected) {
          localStorage.setItem('age_verification_delivery', 'false');
          localStorage.setItem('age_verification_pickup', 'false');
          console.log('📝 Cleared delivery/pickup selections (no delivery available)');
        }
      }
      
      if (pickupButton) {
        console.log('🔘 Pickup button found, adding event listener');
        pickupButton.addEventListener('click', () => {
          console.log('🖱️ Pickup button clicked!');
          
          if (deliveryButton) {
            deliveryButton.classList.remove('active');
            console.log('📝 Removed active class from delivery button');
          }
          pickupButton.classList.add('active');
          console.log('📝 Added active class to pickup button');
          
          localStorage.setItem('age_verification_pickup', 'true');
          localStorage.setItem('age_verification_delivery', 'false');
          console.log('💾 Updated localStorage: pickup=true, delivery=false');
          this.updateDeliveryDisclaimer(matchedStore);
          
          // Hide delivery info, keep service buttons visible
          if (deliveryInfo) {
            deliveryInfo.classList.remove('show');
            console.log('📝 Hid delivery info');
          }
          
          // Update header using popups.js
          console.log('🔄 Calling popups.js updateStoreHeaderFromModal...');
          this.updateHeaderUsingPopups();
          
          console.log('✅ Store update: Pickup selected - completed');
          setTimeout(() => {
            window.location.reload();
          }, 50);
        });
      } else {
        console.warn('⚠️ Pickup button not found!');
      }
      
      if (deliveryButton) {
        console.log('🔘 Delivery button found, adding event listener');
        deliveryButton.addEventListener('click', () => {
          console.log('🖱️ Delivery button clicked!');
          
          if (pickupButton) {
            pickupButton.classList.remove('active');
            console.log('📝 Removed active class from pickup button');
          }
          deliveryButton.classList.add('active');
          console.log('📝 Added active class to delivery button');
          
          localStorage.setItem('age_verification_delivery', 'true');
          localStorage.setItem('age_verification_pickup', 'false');
          console.log('💾 Updated localStorage: delivery=true, pickup=false');
          this.updateDeliveryDisclaimer(matchedStore);
          
          // Show delivery info when delivery is selected and store supports delivery
          if (deliveryInfo) {
            if (hasHubId || hasNormalDelivery) {
              deliveryInfo.classList.add('show');
              console.log('📝 Showed delivery info (delivery selected)');
            } else {
              deliveryInfo.classList.remove('show');
              console.log('📝 Hid delivery info (no delivery capability)');
            }
          }
          
          // Update header using popups.js
          console.log('🔄 Calling popups.js updateStoreHeaderFromModal...');
          this.updateHeaderUsingPopups();
          
          console.log('✅ Store update: Delivery selected - completed');
          setTimeout(() => {
            window.location.reload();
          }, 50);
        });
      } else {
        console.warn('⚠️ Delivery button not found!');
      }

      // Set initial state based on current selection
      if (deliveryInfo) {
        const shouldShowDeliveryInfo =
          isDeliverySelected && (hasHubId || hasNormalDelivery);
        deliveryInfo.classList.toggle('show', shouldShowDeliveryInfo);
        console.log(
          `📝 Initial state: ${shouldShowDeliveryInfo ? 'Showed' : 'Hid'} delivery info`
        );
      }
      this.updateDeliveryDisclaimer(matchedStore);
    }, 100);

     // Handle address safely
     if (matchedStore.address) {
       const { street1 = "", city = "", province = "", zip = "", country = "" } = matchedStore.address;
       this.store_address.innerHTML = `${street1}, ${city}, ${province}, ${zip}, ${country}`.replace(/, ,|, $/g, "");
     }

    // Add pickup time information after address (remove any existing ones first)
    if (this.store_address && this.store_address.parentNode) {
      // Remove any existing pickup time elements to prevent duplicates
      const existingPickupTimes = this.store_address.parentNode.querySelectorAll('.pickup-time');
      existingPickupTimes.forEach(element => element.remove());
      
      // Create new pickup time element
      const pickupTimeElement = document.createElement('p');
      pickupTimeElement.className = 'pickup-time';
      pickupTimeElement.innerHTML = `✓ Pickup available ${matchedStore.hours || '10am - 10pm'}`;
      
      // Insert pickup time after the address element
      this.store_address.parentNode.insertBefore(pickupTimeElement, this.store_address.nextSibling);
      console.log('📝 Added pickup time information (removed any existing duplicates)');
    }

    // Get and append nearest stores
    const nearestStores = this.getNearestStores(matchedStore);
    const storeContainer = document.querySelector('.nearby_stores');
    
    if (storeContainer) {
      this.appendStoreElements(nearestStores, storeContainer);
    } else {
      console.error("Store popup: .nearby_stores container not found");
    }

    // Get and append nearest stores
    // const favouritetStores = this.getFavouriteStores(matchedStore);
    // const favouriteStoreContainer = document.querySelector('.favourite_stores');
    // this.appendStoreElements(nearestStores, favouriteStoreContainer);
  }

   getDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the earth in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in km
    return distance;
  }

  getUserLocation() {
    // First check if we have stored location data
    const storedLat = localStorage.getItem('latitude_ai');
    const storedLon = localStorage.getItem('longitude_ai');
    
    if (storedLat && storedLon) {
      console.log('Store popup: Using stored user location:', storedLat, storedLon);
      return {
        latitude: parseFloat(storedLat),
        longitude: parseFloat(storedLon)
      };
    }
    
    // Fallback: return null if no location data available
    console.log('Store popup: No user location data available');
    return null;
  }

  getNearestStores(matchedStore) {
    if (!matchedStore?.address) return [];
    
    if (!window.stores) {
      console.error("Store popup: window.stores is undefined in getNearestStores");
      return [];
    }

    const allStores = Object.values(window.stores).filter(store => store.store_id !== matchedStore.store_id);

    // Get user's location (customer's location, not store's location)
    const userLocation = this.getUserLocation();
    
    if (!userLocation) {
      console.log('Store popup: No user location available, using selected store location as fallback');
      // FALLBACK: Use selected store location when user location is not available
      return this.getNearestStoresFromStore(matchedStore, allStores);
    }

    // Calculate distances from user's location to all stores (no filtering)
    const storesWithDistance = allStores
      .filter(({ address }) => address?.latitude && address?.longitude) // Ensure valid coordinates
      .map((store) => ({
        store,
        distance: this.getDistance(userLocation.latitude, userLocation.longitude, store.address.latitude, store.address.longitude),
      }))
      .sort((a, b) => a.distance - b.distance);

    console.log('Store popup: Showing all stores sorted by distance');

    return storesWithDistance.slice(0, 5);
  }

  // Fallback method: Get nearest stores based on selected store location
  getNearestStoresFromStore(matchedStore, allStores) {
    console.log('Store popup: Using selected store location for nearby stores calculation');
    
    const { latitude, longitude } = matchedStore.address;
    
    // Calculate distances from selected store to all other stores
    const storesWithDistance = allStores
      .filter(({ address }) => address?.latitude && address?.longitude) // Ensure valid coordinates
      .map((store) => ({
        store,
        distance: this.getDistance(latitude, longitude, store.address.latitude, store.address.longitude),
      }))
      .sort((a, b) => a.distance - b.distance);

    console.log('Store popup (fallback): Showing all stores sorted by distance');

    return storesWithDistance.slice(0, 5);
  }

  getFavouriteStores(matchedStore) {
    if (!matchedStore?.address) return [];

    const allStores = Object.values(window.stores).filter(store => store.store_id === matchedStore.store_id);
    const { latitude, longitude } = matchedStore.address;

    return matchedStore
      .filter(({ address }) => address?.latitude && address?.longitude) // Ensure valid coordinates
      .map((store) => ({
        store,
        distance: this.getDistance(latitude, longitude, store.address.latitude, store.address.longitude),
      }))
      .sort((a, b) => a.distance - b.distance)
      .slice(0, 5);
  }
  
  appendStoreElements(nearestStores, storeContainer) {
    if (!storeContainer) {
      console.error("StoreUpdator: .nearby_stores container not found");
      return;
    }

    nearestStores.forEach(({ store, distance }) => {
      if (!store?.address) return;
      let storeStatus = "Closed"; // default
      if (store.hours_periods && Array.isArray(store.hours_periods)) {
        const { day, time: currentTime } = this.getStoreLocalDateParts(store);
        const todayHours = store.hours_periods.find(h => h.open.day === day);

        if (todayHours) {
          const openTime = todayHours.open.time;
          const closeTime = todayHours.close.time;

          // Handle overnight case (store closes after midnight)
          if (closeTime < openTime) {
            storeStatus = (currentTime >= openTime || currentTime <= closeTime)
              ? "Open"
              : "Closed";
          } else {
            storeStatus = (currentTime >= openTime && currentTime <= closeTime)
              ? "Open"
              : "Closed";
          }
        }
      }


      // console.log(near_status, "openingTime", "closingTime");

      const image = store.img || 'https://cdn.shopify.com/s/files/1/0520/7713/4012/files/Generic_Store_Image_1.webp?v=1730910190';

     
      
      // Check if store is eligible for delivery (TEST MODE: Always allow)
      const isEligibleForDelivery = this.isStoreEligibleForDelivery(store);
      const selectedMethod = localStorage.getItem('age_verification_delivery') === 'true' ? 'delivery' : 'pickup';
      
      let storeDelivery = "Pickup";
      let deliveryEligibilityTag = "";
      
      if (isEligibleForDelivery) {
        storeDelivery = "Pickup";
        deliveryEligibilityTag = '<span class="delivery-eligible-tag">🚚 Express Delivery</span>';
      } else if (selectedMethod === 'delivery' && !isEligibleForDelivery) {
        // Show fallback message when delivery is selected but store doesn't have hub_id
        deliveryEligibilityTag = '<span class="delivery-fallback-tag">🔄 Pickup Only (No Hub ID)</span>';
      }
      
      if (store.has_pickup == false) { 
        storeDelivery = storeDelivery.replace('Pickup &', '').replace('Pickup', ''); 
      }

      const { street1 = "", city = "", province = "", zip = "", country = "", latitude = "", longitude = "" } = store.address;

      // Create service options with tick marks
      const serviceOptions = this.createServiceOptions(store);
      
      const storeElement = document.createElement('div');
      storeElement.classList.add('product__location-section', 'change__location-section');
      storeElement.innerHTML = `
        <section class="selected-store selected-store-ov">
            
          
          <div class="current_address-location">
            <span class="current__location">${store.title}</span> | <span class="status ${storeStatus === "Open" ? "open" : "closed"}">${storeStatus}</span> | <span class="current__distance">${distance.toFixed(2)} km away</span>
            <div class="current__address">${street1}, ${city}, ${province}, ${zip}, ${country}</div>
            <div class="store-service-options">
              ${serviceOptions}
            </div>
          </div>
            <div class="store-info store-update_info">
            <button data-v="${store.store_id}" data-d="${storeDelivery}" data-s="${storeStatus}" data-p="${province}" class="store-change-button">Store Details</button>
            <button data-v="${store.store_id}" data-d="${storeDelivery}" data-s="${storeStatus}" data-p="${province}" class="shop-here-button">Shop Here</button>
            </div>
        </section>`;

      storeContainer.appendChild(storeElement);
    });
  }

  convertTo24Hour(timeStr) {
    if (!timeStr) return null;
    const period = timeStr.slice(-2).toLowerCase(); // "am" or "pm"
    let hour = parseInt(timeStr.slice(0, -2).trim(), 10);

    if (period === "pm" && hour !== 12) hour += 12;
    if (period === "am" && hour === 12) hour = 0;

    return hour;
  }

  isStoreOpen(openHour, closeHour) {
    if (openHour === null || closeHour === null) return "Closed";
    
    const currentTime = new Date();
    const mstTime = new Date(currentTime.toLocaleString("en-US", { timeZone: "America/Denver" }));
    const currentHour = mstTime.getHours();

    return currentHour >= openHour && currentHour < closeHour ? "Open" : "Closed";
  }

  roundToNearestHalf(num) {
    return Math.round(num * 2) / 2;
  }

  // Check if store is eligible for delivery (requires hub_id)
  isStoreEligibleForDelivery(store) {
    // Check if store has hub_id for delivery (no distance restriction)
    const hasHubId = store.hub_id && store.hub_id !== '';
    if (!hasHubId) {
      console.log(`Store ${store.title} has no hub_id, not eligible for delivery`);
      return false;
    }
    
    console.log(`Store ${store.title} - hub_id: ${store.hub_id}, eligible for delivery (no distance restriction)`);
    return true; // No distance restriction - only hub_id matters
  }

  // Update header display when delivery method changes
  updateHeaderDisplay() {
    console.log('🔄 Store update: Updating header display...');
    console.log('🔍 Current localStorage values:', {
      delivery: localStorage.getItem('age_verification_delivery'),
      pickup: localStorage.getItem('age_verification_pickup'),
      globalStore: localStorage.getItem('global_store')
    });
    
    let store = null;
    
    // Try to get store from global_store first
    const globalStore = localStorage.getItem('global_store');
    if (globalStore) {
      try {
        store = JSON.parse(globalStore);
        console.log('📦 Using global_store data:', store);
      } catch (e) {
        console.error('Error parsing global_store:', e);
      }
    }
    
    // Fallback: try to get store from current store data
    if (!store && this.currentStore) {
      store = this.currentStore;
      console.log('📦 Using current store data:', store);
    }
    
    // Fallback: try to get store from window.stores
    if (!store && window.stores) {
      const storeId = localStorage.getItem('global_store_id');
      if (storeId) {
        store = Object.values(window.stores).find(s => s.store_id === storeId);
        console.log('📦 Using window.stores data:', store);
      }
    }
    
    if (store) {
      // Use popups.js for header updates
      if (window.updateStoreHeaderFromModal) {
        window.updateStoreHeaderFromModal(store);
      }
    } else {
      console.warn('⚠️ No store data available for header update');
    }
  }

  // Update header using popups.js (consolidated approach)
  updateHeaderUsingPopups() {
    console.log('🔄 Store update: Updating header using popups.js...');
    
    // Get the current store from the modal's store selection
    const currentStoreId = localStorage.getItem('global_store_id');
    console.log('🔍 Current store ID:', currentStoreId);
    
    if (currentStoreId && window.stores) {
      // Find the current store in window.stores
      const currentStore = Object.values(window.stores).find(store => store.store_id === currentStoreId);
      console.log('📦 Found current store:', currentStore);
      
      if (currentStore) {
        // Update global_store for consistency
        localStorage.setItem('global_store', JSON.stringify(currentStore));
        console.log('💾 Updated global_store with current store');
        
        // Also update the modal display with the current store
        this.restoreSelectedStoreInModal(currentStore);
        
        // Call popups.js to update header - use direct header update instead of modal function
        this.updateHeaderDirectly(currentStore);
        console.log('✅ Header updated directly');
      } else {
        console.warn('⚠️ Current store not found in window.stores');
      }
    } else {
      console.warn('⚠️ No current store ID or window.stores not available');
    }
  }

  // Direct header update function to avoid conflicts
  updateHeaderDirectly(store) {
    console.log('🔄 Store update: Direct header update for store:', store.title);
    
    if (!store || !store.address) {
      console.warn('⚠️ Store data incomplete for header update');
      return;
    }
    
    // Prevent multiple simultaneous updates
    if (this.isUpdatingHeader) {
      console.log('📦 Already updating header, skipping duplicate call');
      return;
    }
    this.isUpdatingHeader = true;

    // Update localStorage with store data - determine store status
    let storeStatus = "Closed"; // default
    if (store.hours_periods && Array.isArray(store.hours_periods)) {
      const now = new Date();
      const day = now.getDay();
      const currentTime = now.getHours().toString().padStart(2, "0") + now.getMinutes().toString().padStart(2, "0");
      const todayHours = store.hours_periods.find(h => h.open.day === day);
      if (todayHours) {
        const openTime = todayHours.open.time;
        const closeTime = todayHours.close.time;
        if (closeTime < openTime) {
          storeStatus = (currentTime >= openTime || currentTime <= closeTime) ? "Open" : "Closed";
        } else {
          storeStatus = (currentTime >= openTime && currentTime <= closeTime) ? "Open" : "Closed";
        }
      }
    }
    const status_ai = storeStatus;
    localStorage.setItem('global_store_status', status_ai);
    localStorage.setItem('global_store_distance', store.distance || '');
    
    // Get delivery method from localStorage - check both delivery and pickup flags
    const isDeliverySelected = localStorage.getItem('age_verification_delivery') === 'true';
    const isPickupSelected = localStorage.getItem('age_verification_pickup') === 'true';
    
    // Determine delivery method based on what's actually selected
    let deliveryMethod = 'Pickup'; // default
    if (isDeliverySelected && !isPickupSelected) {
      // Check if store has express delivery capability
      const hasHubId = store.hub_id && store.hub_id !== '';
      if (hasHubId) {
        deliveryMethod = 'Express Delivery';
      } else {
        deliveryMethod = 'Delivery';
      }
    } else if (isPickupSelected && !isDeliverySelected) {
      deliveryMethod = 'Pickup';
    } else {
      // If both are selected or neither is selected, check the store's capabilities
      const hasHubId = store.hub_id && store.hub_id !== '';
      if (hasHubId && isDeliverySelected) {
        deliveryMethod = 'Express Delivery';
      } else if (isDeliverySelected) {
        deliveryMethod = 'Delivery';
      } else {
        deliveryMethod = 'Pickup';
      }
    }
    
    console.log('🚚 Delivery method determined:', deliveryMethod, 'delivery:', isDeliverySelected, 'pickup:', isPickupSelected);
    console.log('🔍 Store delivery capabilities:', {
      'hub_id': store.hub_id,
      'has_delivery': store.has_delivery,
      'has_pickup': store.has_pickup
    });
    
    // Update header elements directly
    const updateHeaderElements = () => {
      const storeNameElements = document.querySelectorAll('.js-header-store-name');
      const storeAddressElements = document.querySelectorAll('.js-header-street');

      console.log('🔍 Found store name elements:', storeNameElements.length);
      console.log('🔍 Found store address elements:', storeAddressElements.length);

      if (storeNameElements.length === 0 || storeAddressElements.length === 0) {
        console.log('⏳ Header elements not found, retrying in 100ms...');
        setTimeout(updateHeaderElements, 100);
        return;
      }

      // Update store name elements with delivery method and city
      storeNameElements.forEach((element, index) => {
        console.log(`📝 Updating store name element ${index}:`, element);
        element.textContent = `${deliveryMethod} | ${store.address.city}`;
      });

      // Update store address elements
      storeAddressElements.forEach((element, index) => {
        console.log(`📝 Updating store address element ${index}:`, element);
        element.textContent = store.address.street1;
      });
      
      console.log('✅ Store update: Direct header update completed');
    };

    // Start the update process
    updateHeaderElements();
    
    // Reset the flag
    this.isUpdatingHeader = false;
  }

  // Force update modal with currently selected store
  forceUpdateModalWithCurrentStore() {
    console.log('🔄 Store update: Force updating modal with current store...');
    
    // Always use the most current store ID from localStorage
    const currentStoreId = localStorage.getItem('global_store_id');
    console.log('🔍 Force update - Current store ID from localStorage:', currentStoreId);
    console.log('🔍 Force update - Instance store ID:', this.current_store_id);
    
    // Update the instance store ID to match localStorage
    this.current_store_id = currentStoreId;
    
    if (currentStoreId && window.stores) {
      const currentStore = Object.values(window.stores).find(store => store.store_id === currentStoreId);
      console.log('📦 Force update - Found current store:', currentStore?.title || 'Not found');
      
      if (currentStore) {
        // Update the modal display immediately
        this.restoreSelectedStoreInModal(currentStore);
        console.log('✅ Modal force updated with current store:', currentStore.title);
      } else {
        console.warn('⚠️ Force update - Current store not found in window.stores for ID:', currentStoreId);
      }
    } else {
      console.warn('⚠️ Force update - No current store ID or window.stores not available');
      console.log('🔍 Available stores:', window.stores ? Object.keys(window.stores) : 'undefined');
    }
  }

  // Global function to update modal when store is selected
  updateModalWithSelectedStore(storeId) {
    console.log('🔄 Store update: updateModalWithSelectedStore called with storeId:', storeId);
    
    // Update the global store ID
    localStorage.setItem('global_store_id', storeId);
    
    // Force update the modal
    this.forceUpdateModalWithCurrentStore();
    
    console.log('✅ Modal updated with selected store');
  }

  // Note: Global function is defined outside the class

  // Setup observer to watch for modal opening
  setupModalObserver() {
    const modal = document.querySelector('[data-popup-type="store-update"]');
    if (modal) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (modal.classList.contains('active')) {
              console.log('👀 Modal opened, syncing immediately...');
              console.log('🔍 Current store ID before sync:', this.current_store_id);
              console.log('🔍 Current store ID from localStorage:', localStorage.getItem('global_store_id'));
              
              // Force update the modal with the current store
              setTimeout(() => {
                this.forceUpdateModalWithCurrentStore();
                // Also ensure the modal displays the correct store details
                this.setCurrentStoreDetails();
              }, 150); // Slightly longer delay to ensure modal is fully rendered
            }
          }
        });
      });
      
      observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
      console.log('👀 Modal observer set up');
    } else {
      console.warn('⚠️ Store update modal not found for observer');
    }
  }

  // Restore header state on page load using popups.js
  restoreHeaderStateOnLoad() {
    console.log('🔄 Store update: Restoring header state on page load using popups.js...');
    
    // Check if we have stored store data
    const globalStore = localStorage.getItem('global_store');
    const storeId = localStorage.getItem('global_store_id');
    const deliveryMethod = localStorage.getItem('age_verification_delivery');
    const pickupMethod = localStorage.getItem('age_verification_pickup');
    
    console.log('🔍 Stored data on page load:', {
      globalStore: !!globalStore,
      storeId,
      deliveryMethod,
      pickupMethod
    });
    
    // Debug: Check if delivery/pickup flags are properly set
    console.log('🔍 Delivery/Pickup flags:', {
      'age_verification_delivery': localStorage.getItem('age_verification_delivery'),
      'age_verification_pickup': localStorage.getItem('age_verification_pickup'),
      'global_store_id': localStorage.getItem('global_store_id')
    });
    
    // Only restore if we have valid store data
    if (globalStore && storeId) {
      try {
        const store = JSON.parse(globalStore);
        console.log('📦 Restoring header with stored store:', store.title);
        
        // Update header directly
        this.updateHeaderDirectly(store);
        console.log('✅ Header restored directly');
        
        // Also restore the selected store in the modal
        this.restoreSelectedStoreInModal(store);
        
        console.log('✅ Header state restored successfully');
      } catch (e) {
        console.error('Error parsing stored global_store:', e);
        // Try to restore from store ID
        this.restoreFromStoreId(storeId);
      }
    } else if (storeId) {
      console.log('📦 No global_store, trying to restore from store ID');
      this.restoreFromStoreId(storeId);
    } else {
      console.log('ℹ️ No stored store data found, header will use default state');
    }
  }

  // Restore header from store ID using popups.js
  restoreFromStoreId(storeId) {
    if (window.stores) {
      const store = Object.values(window.stores).find(s => s.store_id === storeId);
      if (store) {
        console.log('📦 Found store by ID, updating header:', store.title);
        // Update global_store for consistency
        localStorage.setItem('global_store', JSON.stringify(store));
        
        // Update header directly
        this.updateHeaderDirectly(store);
        console.log('✅ Header updated directly');
        
        // Also restore the selected store in the modal
        this.restoreSelectedStoreInModal(store);
      } else {
        console.warn('⚠️ Store not found in window.stores for ID:', storeId);
      }
    } else {
      console.warn('⚠️ window.stores not available for restoration');
      // Retry after a delay
      setTimeout(() => {
        this.restoreFromStoreId(storeId);
      }, 1000);
    }
  }

  // Synchronize store display between header and modal (using popups.js)
  synchronizeStoreDisplay(store) {
    console.log('🔄 Store update: Synchronizing store display for:', store.title);
    console.log('🔍 Synchronizing store data:', {
      title: store.title,
      city: store.address?.city,
      street: store.address?.street1,
      store_id: store.store_id,
      distance: store.distance
    });
    
    // Update header directly
    this.updateHeaderDirectly(store);
    console.log('✅ Header updated directly');
    
    // Update modal with the same store
    this.restoreSelectedStoreInModal(store);
    
    // Ensure global_store is up to date
    localStorage.setItem('global_store', JSON.stringify(store));
    
    console.log('✅ Store display synchronized successfully');
  }

  // Restore the selected store in the modal
  restoreSelectedStoreInModal(store) {
    console.log('🔄 Store update: Restoring selected store in modal:', store.title);
    console.log('🔍 Store data:', {
      title: store.title,
      city: store.address?.city,
      distance: store.distance,
      store_id: store.store_id,
      hub_id: store.hub_id
    });
    
    // Update the modal display with the selected store
    if (this.current_store_title) {
      this.current_store_title.textContent = store.title;
      console.log('📝 Updated store title in modal:', store.title);
    }
    this.updateDeliveryDisclaimer(store);
    
    if (this.store_address && store.address) {
      const address = `${store.address.street1}, ${store.address.city}, ${store.address.province}, ${store.address.zip}, ${store.address.country}`;
      this.store_address.textContent = address;
      console.log('📝 Updated store address in modal:', address);
    }
    
    // Update store status
    if (this.store_status && this.store_status.length > 0) {
      let storeStatus = "Closed"; // default
      if (store.hours_periods && Array.isArray(store.hours_periods)) {
        const { day, time: currentTime } = this.getStoreLocalDateParts(store);
        const todayHours = store.hours_periods.find(h => h.open.day === day);
        if (todayHours) {
          const openTime = todayHours.open.time;
          const closeTime = todayHours.close.time;
          if (closeTime < openTime) {
            storeStatus = (currentTime >= openTime || currentTime <= closeTime) ? "Open" : "Closed";
          } else {
            storeStatus = (currentTime >= openTime && currentTime <= closeTime) ? "Open" : "Closed";
          }
        }
      }
      const status = storeStatus;
      this.store_status.forEach(element => {
        element.textContent = status;
        element.classList.remove('open', 'closed');
        element.classList.add(status.toLowerCase());
      });
      console.log('📝 Updated store status in modal:', status);
    }
    
    // Update store distance if available
    if (this.store_distance && store.distance) {
      const rawDistance = parseFloat(store.distance);
      const roundedDistance = this.roundToNearestHalf(rawDistance);
      
      // Check if distance seems reasonable (less than 1000 km)
      if (rawDistance > 1000) {
        console.warn('⚠️ Distance seems too large:', rawDistance, 'km. Recalculating...');
        // Try to recalculate distance
        const userLocation = this.getUserLocation();
        if (userLocation && store.address && store.address.latitude && store.address.longitude) {
          const recalculatedDistance = this.getDistance(
            userLocation.latitude, 
            userLocation.longitude, 
            parseFloat(store.address.latitude), 
            parseFloat(store.address.longitude)
          );
          console.log('🔄 Recalculated distance:', recalculatedDistance, 'km');
          this.store_distance.textContent = `${this.roundToNearestHalf(recalculatedDistance)} km away`;
        } else {
          console.warn('⚠️ Cannot recalculate distance - missing location data');
          this.store_distance.textContent = `${roundedDistance} km away`;
        }
      } else {
        this.store_distance.textContent = `${roundedDistance} km away`;
        console.log('📝 Updated store distance in modal:', roundedDistance, 'from raw distance:', store.distance);
      }
    } else {
      console.log('⚠️ No distance data available for store:', store.title);
      // Try to calculate distance if we have location data
      const userLocation = this.getUserLocation();
      if (userLocation && store.address && store.address.latitude && store.address.longitude) {
        const calculatedDistance = this.getDistance(
          userLocation.latitude, 
          userLocation.longitude, 
          parseFloat(store.address.latitude), 
          parseFloat(store.address.longitude)
        );
        console.log('🔄 Calculated distance:', calculatedDistance, 'km');
        this.store_distance.textContent = `${this.roundToNearestHalf(calculatedDistance)} km away`;
      } else {
        this.store_distance.textContent = 'Distance unavailable';
      }
    }
    
    // Update service options
    if (this.fullfill) {
      const serviceOptions = this.createServiceOptions(store);
      const serviceOptionsContainer = this.fullfill.querySelector('.store-service-options');
      if (serviceOptionsContainer) {
        serviceOptionsContainer.innerHTML = serviceOptions;
        console.log('📝 Updated service options in modal:', serviceOptions);
      }
    }
    
    // Update delivery/pickup button states (async)
    this.updateDeliveryPickupButtons(store).catch(error => {
      console.error('Error updating delivery/pickup buttons:', error);
    });
    
    console.log('✅ Selected store restored in modal successfully');
  }

  // Check express delivery availability via API
 async checkExpressDeliveryForStore(store) {
  if (!store.hub_id) return false;

  // cache key by hub_id
  if (!this._expressCache) this._expressCache = {};
  if (this._expressCache[store.hub_id] !== undefined) {
    return this._expressCache[store.hub_id];
  }

  try {
    const userLocation = this.getUserLocation();
    if (!userLocation) return false;

    const response = await fetch('https://app.cannacabana.com/api/is-express-delivery', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        lat: userLocation.latitude.toString(),
        lng: userLocation.longitude.toString(),
        zone: store.hub_id
      })
    });

    const data = await response.json();
    this._expressCache[store.hub_id] = data.is_express === true;
    return this._expressCache[store.hub_id];
  } catch (err) {
    console.error('Express check failed:', err);
    this._expressCache[store.hub_id] = false;
    return false;
  }
}

  // Update delivery/pickup button states based on stored preferences and API validation
  async updateDeliveryPickupButtons(store) {
    const isDeliverySelected = localStorage.getItem('age_verification_delivery') === 'true';
    const isPickupSelected = localStorage.getItem('age_verification_pickup') === 'true';
    
    console.log('🔄 Updating button states:', { isDeliverySelected, isPickupSelected });
    console.log('🔍 Raw localStorage values:', {
      delivery: localStorage.getItem('age_verification_delivery'),
      pickup: localStorage.getItem('age_verification_pickup')
    });
    
    // Check if store has any delivery capability
    const hasHubId = store.hub_id && store.hub_id !== '';
    const hasNormalDelivery = store.has_delivery === true;
    const hasAnyDelivery = hasHubId || hasNormalDelivery;
    let isExpressDeliveryAvailable = false;
    
    if (hasHubId) {
      // Check express delivery availability via API
      isExpressDeliveryAvailable = await this.checkExpressDeliveryForStore(store);
      console.log('🚀 Express delivery available:', isExpressDeliveryAvailable);
    }
    
    // Update both buttons based on delivery capability
    const pickupButton = this.fullfill?.querySelector('.pickup-button');
    const deliveryButton = this.fullfill?.querySelector('.delivery-button');
    console.log('🔍 Pickup button found:', !!pickupButton);
    console.log('🔍 Delivery button found:', !!deliveryButton);
    
    if (hasAnyDelivery) {
      // Show both buttons for any store with delivery capability
      if (pickupButton) {
        pickupButton.style.display = '';
        pickupButton.disabled = false;
        if (isPickupSelected) {
          pickupButton.classList.add('active');
          console.log('📝 Activated pickup button (delivery available)');
        } else {
          pickupButton.classList.remove('active');
          console.log('📝 Deactivated pickup button (delivery available)');
        }
      }
      
      if (deliveryButton) {
        deliveryButton.style.display = '';
        deliveryButton.disabled = false;
        if (isDeliverySelected) {
          deliveryButton.classList.add('active');
          console.log('📝 Activated delivery button (delivery available)');
        } else {
          deliveryButton.classList.remove('active');
          console.log('📝 Deactivated delivery button (delivery available)');
        }
      }
    } else {
      // Hide both buttons when no delivery is available
      if (pickupButton) {
        pickupButton.style.display = 'none';
        pickupButton.disabled = true;
        pickupButton.classList.remove('active');
        console.log('📝 Hidden pickup button (no delivery available)');
      }
      
      if (deliveryButton) {
        deliveryButton.style.display = 'none';
        deliveryButton.disabled = true;
        deliveryButton.classList.remove('active');
        console.log('📝 Hidden delivery button (no delivery available)');
      }
      
      // Clear selections if delivery was selected but not available
      if (isDeliverySelected) {
        localStorage.setItem('age_verification_delivery', 'false');
        localStorage.setItem('age_verification_pickup', 'false');
        console.log('📝 Cleared delivery/pickup selections (no delivery available)');
      }
    }
    
    // Update delivery info visibility for delivery selections
    const deliveryInfo = this.fullfill?.querySelector('.same-day-delivery');
    console.log('🔍 Delivery info found:', !!deliveryInfo);
    if (deliveryInfo) {
      if (isDeliverySelected && (hasNormalDelivery || isExpressDeliveryAvailable)) {
        deliveryInfo.classList.add('show');
        console.log('📝 Showed delivery info (delivery selected)');
      } else {
        deliveryInfo.classList.remove('show');
        console.log('📝 Hid delivery info (delivery not selected or unavailable)');
      }
    } else {
      console.warn('⚠️ Delivery info not found in updateDeliveryPickupButtons');
    }
    this.updateDeliveryDisclaimer(store);
  }

  // Note: Header updates are now handled by popups.js to avoid conflicts

  // Note: All header updates are now handled by popups.js to avoid conflicts

  // Create service options with tick marks
  createServiceOptions(store) {
    const hasHubId = store.hub_id && store.hub_id !== '';
    const isExpressDelivery = store.store_id === '3162'; // Special case for express delivery
    
    let options = [];
  
    // Always show pickup for every store
    options.push(`<span class="service-option pickup-option">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 6px;">
        <circle cx="12" cy="12" r="10" stroke="#15ED66" stroke-width="2"/>
        <path d="M9 12l2 2 4-4" stroke="#15ED66" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Pickup
    </span>`);
    
    // Show delivery if hub_id exists
    if (hasHubId) {
      if (isExpressDelivery) {
        options.push(`<span class="service-option delivery-option express">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 6px;">
            <circle cx="12" cy="12" r="10" stroke="#15ED66" stroke-width="2"/>
            <path d="M9 12l2 2 4-4" stroke="#15ED66" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Express Delivery
        </span>`);
      } else {
        options.push(`<span class="service-option delivery-option">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 6px;">
            <circle cx="12" cy="12" r="10" stroke="#15ED66" stroke-width="2"/>
            <path d="M9 12l2 2 4-4" stroke="#15ED66" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Express Delivery
        </span>`);
      }
    }
    
    return options.join(' ');
  }

  // Get store closing time for delivery cutoff
  getStoreClosingTime(store) {
    if (!store.hours_periods || !Array.isArray(store.hours_periods)) {
      return '7 PM'; // Default fallback
    }

    // Find the latest closing time across all days
    let latestCloseTime = '7:00 PM'; // Default fallback
    
    store.hours_periods.forEach(period => {
      if (period.close && period.close.time) {
        const closeTime = this.formatTime(period.close.time);
        if (this.isTimeLater(closeTime, latestCloseTime)) {
          latestCloseTime = closeTime;
        }
      }
    });

    return latestCloseTime;
  }

  // Get store delivery days based on operating hours
  getStoreDeliveryDays(store) {
    if (!store.hours_periods || !Array.isArray(store.hours_periods)) {
      return 'Sat – Sun, 12PM – 8PM'; // Default fallback
    }

    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const operatingDays = [];
    const timeRanges = [];

    store.hours_periods.forEach(period => {
      if (period.open && period.close) {
        const dayName = dayNames[period.open.day];
        const openTime = this.formatTime(period.open.time);
        const closeTime = this.formatTime(period.close.time);
        
        if (!operatingDays.includes(dayName)) {
          operatingDays.push(dayName);
        }
        
        if (!timeRanges.includes(`${openTime} – ${closeTime}`)) {
          timeRanges.push(`${openTime} – ${closeTime}`);
        }
      }
    });

    if (operatingDays.length === 0) {
      return 'Sat – Sun, 12 PM – 8 PM'; // Default fallback
    }

    const dayRange = operatingDays.length > 1 ? 
      `${operatingDays[0]} – ${operatingDays[operatingDays.length - 1]}` : 
      operatingDays[0];
    
    const timeRange = timeRanges[0] || '12 PM – 7 PM';
    
    return `${dayRange}, ${timeRange}`;
  }

  // Format time from HHMM format to readable format
  formatTime(timeString) {
    if (!timeString || timeString.length !== 4) return '7:00 PM';
    
    const hours = parseInt(timeString.substring(0, 2));
    const minutes = timeString.substring(2, 4);
    
    let displayHours = hours;
    let period = 'AM';
    
    if (hours === 0) {
      displayHours = 12;
    } else if (hours > 12) {
      displayHours = hours - 12;
      period = 'PM';
    } else if (hours === 12) {
      period = 'PM';
    }
    
    return `${displayHours}:${minutes} ${period}`;
  }

  // Check if one time is later than another
  isTimeLater(time1, time2) {
    const parseTime = (time) => {
      const [timePart, period] = time.split(' ');
      const [hours, minutes] = timePart.split(':');
      let hour24 = parseInt(hours);
      
      if (period === 'PM' && hour24 !== 12) hour24 += 12;
      if (period === 'AM' && hour24 === 12) hour24 = 0;
      
      return hour24 * 60 + parseInt(minutes);
    };
    
    return parseTime(time1) > parseTime(time2);
  }

  handleStoreList() {
    const all_store_array = Object.values(window.stores).flat();
    const store_ids = [];
    this.store_list.innerHTML = "";
    all_store_array.forEach(store => {
          const store_line_item = `${store.address.city} - ${store.address.street1} ${store.distance ? '(' + store.distance.toFixed(0) + 'km)' : ''}`;
          const option = document.createElement('a');
          option.setAttribute('data-v', store.store_id);
          option.setAttribute('href', `/?sID=${store.store_id}`);
          option.textContent = store_line_item;
          option.setAttribute('data-p', store.address.province);
          this.store_list.appendChild(option);
          store_ids.push(store.store_id);
      });
    
  }
  
  handleStoreSearch(event) {
    const searchQuery = event.target.value.toLowerCase();
    const links = this.store_list.querySelectorAll('a');
    
    console.log('Store popup search: Searching for', searchQuery);

    if (searchQuery.length > 0) {
         this.store_dropdown.classList.add('active');
    } else {
        this.store_dropdown.classList.remove('active');
    }

    links.forEach(link => {
        const storeId = link.getAttribute('data-v');
        
        // Get store data from window.stores
        let store = null;
        if (storeId && window.stores) {
            store = Object.values(window.stores).find(s => s.store_id === storeId);
        }
        
        if (!store) {
            link.style.display = 'none';
            return;
        }
        
        // Create searchable text from multiple fields
        let searchableText = link.textContent.toLowerCase();
        if (store && store.address) {
            const address = store.address;
            searchableText += ' ' + [
                address.city || '',
                address.province || '',
                address.zip || '',
                address.street1 || '',
                address.country || '',
                store.title || ''
            ].join(' ').toLowerCase();
        }
        
        const normalizedText = searchableText.replace(/-/g, ' ');

        if (searchableText.includes(searchQuery) || normalizedText.includes(searchQuery)) {
            link.style.display = ''; // Show link
        } else {
            link.style.display = 'none'; // Hide link
        }
    });
    
    // Check if any results are visible after searching
    const visibleLinks = Array.from(links).filter(link => link.style.display !== 'none');
    
    // Remove any existing "no results" message
    const existingNoResults = this.store_list.querySelector('.no-search-results');
    if (existingNoResults) {
        existingNoResults.remove();
    }
    
    // Show "no results" message if no visible links
    if (visibleLinks.length === 0 && searchQuery.length > 0) {
        const noResultsMessage = document.createElement('div');
        noResultsMessage.className = 'no-search-results';
        noResultsMessage.style.cssText = `
          text-align: center;
          padding: 1rem;
          color: #666D80;
          font-size: 14px;
          background-color: #F9F9F9;
          border: 1px solid #E5E5E5;
          border-radius: 8px;
          margin: 0.5rem 0;
        `;
        noResultsMessage.innerHTML = `
          <div style="margin-bottom: 4px;">🔍</div>
          <strong>No stores found matching "${searchQuery}"</strong>
        `;
        this.store_list.appendChild(noResultsMessage);
    }
  }
  handleShopHere() {
  document.body.addEventListener('click', (event) => {
    if (event.target.classList.contains('store-change-button')) {
      event.preventDefault();
      this.updateStore(event.target);
    }
     if (event.target.classList.contains('shop-here-button')) {
      event.preventDefault();
      this.shopHere(event.target);
    }
  });
}
  handleStoreUpdate() {
     this.store_list.querySelectorAll('a').forEach((event) => {
      event.addEventListener('click', (event) => {
      event.preventDefault();
      const target = event.target;
        const store_Id = target.getAttribute('data-v');
        const province = target.getAttribute('data-p');

        const all_store_array = Object.values(window.stores).flat();
        const selectedStore = all_store_array.find(store => store.store_id === store_Id);
        if (selectedStore) {
            localStorage.setItem('global_store_id', store_Id);
            localStorage.setItem('global_province', province);
            localStorage.setItem('global_store', JSON.stringify(selectedStore));
            
            // Update header immediately before page reload
            this.updateHeaderDirectly(selectedStore);
            console.log('✅ Header updated immediately for store selection');
            
            this.clearCart().then(() => {
              const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('sID', store_Id);
                window.location.href = currentUrl.toString();
          });
        }

      })  
      
    });
  }

  updateStore(target) {
    const store_Id = target.getAttribute('data-v');
    const province = target.getAttribute('data-p');
    const store_delivery = target.getAttribute('data-d');
    const store_stat = target.getAttribute('data-s');

    const selectedStore = Object.values(window.stores).find(store => store.store_id === store_Id);
   
    if (selectedStore) {
      localStorage.setItem('global_store_id', store_Id);
      localStorage.setItem('global_province', province);
      localStorage.setItem('global_store', JSON.stringify(selectedStore));
      
      // Update header immediately before page reload
      this.updateHeaderDirectly(selectedStore);
      console.log('✅ Header updated immediately for store update');

         this.clearCart().then(() => {
          const storeName = selectedStore.title.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
          const storePageUrl = `/pages/store/${storeName}/?sID=${store_Id}`;
          window.location.href = storePageUrl;
      });
    }
  }

  shopHere(target) {
    const store_Id = target.getAttribute('data-v');
    const province = target.getAttribute('data-p');
    const store_delivery = target.getAttribute('data-d');
    const store_stat = target.getAttribute('data-s');

    const selectedStore = Object.values(window.stores).find(store => store.store_id === store_Id);
   
    if (selectedStore) {
      localStorage.setItem('global_store_id', store_Id);
      localStorage.setItem('global_province', province);
      localStorage.setItem('global_store', JSON.stringify(selectedStore));
      
      // Update header immediately before page reload
      this.updateHeaderDirectly(selectedStore);
      console.log('✅ Header updated immediately for shop here');
     
     
      this.clearCart().then(() => {
          const url = new URL(window.location.href);
          url.searchParams.set('sID', store_Id);
          const newUrl = url.toString();
          window.location.href = newUrl;
      });
    }
  }
  
  async clearCart() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
    }
  }
  
  // refreshStoreList method removed - using page reload instead
  
  retryInitialization() {
    console.log('Store popup: Retrying initialization');
    if (window.stores) {
      console.log('Store popup: Stores now available, initializing');
      if (this.current_store_title) {
        this.setCurrentStoreDetails();
      }
    } else {
      console.log('Store popup: Stores still not available, will retry again');
      setTimeout(() => {
        this.retryInitialization();
      }, 1000);
    }
  }
  
  
}

customElements.define("store-updator", StoreUpdator);

// Add global function for manual testing
window.testHeaderUpdate = () => {
  console.log('🧪 Manual header update test triggered');
  const storeUpdate = new StoreUpdate();
  storeUpdate.updateHeaderDisplay();
};

// Global function for other scripts to call
window.updateStoreModalWithSelectedStore = function(storeId) {
  console.log('🌐 Global function called: updateStoreModalWithSelectedStore with storeId:', storeId);
  // Get the store updator instance and call the method
  const storeUpdator = document.querySelector('store-updator');
  if (storeUpdator) {
    storeUpdator.updateModalWithSelectedStore(storeId);
  } else {
    console.warn('⚠️ Store updator element not found');
  }
};
